export default[
    {
        path: '/ambiente/trabalhador/lista',
        name: 'lista ambiente de trabalhor', 
        component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    },
    {
        path: '/ambiente/trabalhador/cadastro/:trabalhador_id',
        name: 'cadastro dados ambiente de trabalhor', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/ambiente/trabalhador/editar/:id',
        name: 'editar dados ambiente de trabalhor', 
        component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    },
]
